import FormattedList from 'I18n/components/FormattedList';
import MissingLabel from 'automation-ui-core/components/MissingLabel';
import PropertyName from 'automation-ui-references/object-type-properties/PropertyName';
import TeamName from 'automation-ui-references/customer-data/TeamName';
import UserName from 'automation-ui-references/customer-data/UserName';
import { jsx as _jsx } from "react/jsx-runtime";
export default function EmailNotificationActionRecipients({
  actionMetadata: {
    teamIds,
    userIds,
    ownerProperties
  },
  flowObjectTypeId
}) {
  const users = (userIds || []).map(userId => /*#__PURE__*/_jsx("strong", {
    children: /*#__PURE__*/_jsx(UserName, {
      id: userId,
      href: null
    })
  }, `user-${userId}`));
  const teams = (teamIds || []).map(teamId => /*#__PURE__*/_jsx("strong", {
    children: /*#__PURE__*/_jsx(TeamName, {
      id: teamId,
      href: null
    })
  }, `team-${teamId}`));
  const owners = (ownerProperties || []).map(propertyName => /*#__PURE__*/_jsx(PropertyName, {
    objectTypeId: flowObjectTypeId,
    propertyName: propertyName
  }, `property-${propertyName}`));
  const recipients = [...users, ...teams, ...owners];
  return recipients.length ? /*#__PURE__*/_jsx(FormattedList, {
    children: recipients
  }) : /*#__PURE__*/_jsx(MissingLabel, {
    type: "recipient"
  });
}